import * as React from 'react'

class Map extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        let { cmsData } = this.props;
       
        return (
            <>
                <div className="row">
                    <div className="col-12 col-lg-4 pl-lg-0 pr-lg-7">
                        <ul className="ecf-contact-us__map__info">
                            <li>
                                <i className="fas fa-map-marker-alt"></i>
                                <h5>{cmsData.map.address_label}</h5>
                                <p>{cmsData.map.address}</p>
                            </li>
                            <li>
                                <i className="fas fa-phone"></i>
                                <p>{cmsData.map.phone}</p>
                            </li>
                        </ul>
                    </div>
                    <div className="col-12 col-lg-8 pl-lg-2 pr-lg-0 mt-4 mt-lg-0">
                        <div className="ecf-contact-us__address-you" dangerouslySetInnerHTML={{__html: cmsData.map.html}}>
                            {/* <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d259.886474067877!2d103.84403628335147!3d1.296875781404468!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da18403875d125%3A0xe6367240ba1d7bfa!2sEtonHouse%20International%20Holdings!5e0!3m2!1svi!2s!4v1622450102933!5m2!1svi!2s" width="600" height="450" allowFullScreen="" loading="lazy"></iframe> */}
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default Map;